import { create } from "zustand";
import { UiNotification } from "../mappers/mapServerEventToUi";

type LastLiveEvent = {
  id: string;
  type: string;
  requestUuid?: string;
} | null;

type State = {
  items: UiNotification[];
  unreadCount: number;
  lastLiveEvent: LastLiveEvent;

  setLastLiveEvent: (event: LastLiveEvent) => void;
  addOrUpdate: (notification: UiNotification) => void;
  setUnreadCount: (count: number) => void;
  syncFromSocket: (params: {
    items: UiNotification[];
    unreadCount: number;
  }) => void;
  markReadLocal: (id: string) => void;
  clear: () => void;
};

export const useNotificationsStore = create<State>((set) => ({
  items: [],
  unreadCount: 0,
  lastLiveEvent: null,

  addOrUpdate: (notification) =>
    set((state) => {
      const idx = state.items.findIndex((item) => item.id === notification.id);

      if (idx === -1) {
        return {
          items: [notification, ...state.items].slice(0, 50),
        };
      }

      const items = [...state.items];
      items[idx] = {
        ...items[idx],
        ...notification,
      };

      return { items };
    }),
  setUnreadCount: (count) =>
    set(() => ({
      unreadCount: count,
    })),
  syncFromSocket: ({ items: incomingItems, unreadCount }) =>
    set((state) => {
      const map = new Map<string, UiNotification>();

      state.items.forEach((item) => map.set(item.id, item));

      incomingItems.forEach((item) => {
        const prev = map.get(item.id);

        map.set(item.id, {
          ...prev,
          ...item,
        });
      });

      return {
        items: Array.from(map.values()).slice(0, 50),
        unreadCount,
      };
    }),
  setLastLiveEvent: (event) =>
    set({
      lastLiveEvent: event,
    }),
  markReadLocal: (id) =>
    set((state) => {
      const idx = state.items.findIndex((item) => item.id === id);
      if (idx === -1) return state;

      const target = state.items[idx];
      if (target.isRead) return state;

      const items = [...state.items];
      items[idx] = {
        ...target,
        isRead: true,
      };

      return {
        items,
        unreadCount: Math.max(0, state.unreadCount - 1),
      };
    }),
  clear: () => ({
    items: [],
    unreadCount: 0,
  }),
}));
